import React from 'react';
// import { Screen, ScreenSlice } from 'react-screen';
import Screens from '../../screens';

/* Home component */
const Home = () => {
	return (
		 <Screens.Home.Terms/>
	);
};

export default Home;
